import { useEffect } from 'react';
import { getScrollbarWidth } from '../utils/dom/dom';

const useDisableScroll = (isEnabled = true) => {
  useEffect(() => {
    if (isEnabled) {
      const scrollbarWidth = getScrollbarWidth();

      if (scrollbarWidth) {
        document.body.style.width = `calc(100% - ${scrollbarWidth}px)`;
      }

      document.body.style.overflow = 'hidden';

      return () => {
        if (scrollbarWidth) {
          document.body.style.width = '100%';
        }

        document.body.style.overflow = 'auto';
      };
    }
  }, [isEnabled]);

  return isEnabled;
};

export default useDisableScroll;
